module.exports = __webpack_public_path__ + "fox2-white.png";